import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../generic-components/Heading';
import { BalanceView } from '../../components/BalanceView';
import { ReactComponent as IconSavingAccountBalance } from '../../../../assets/dashboard/saving-widget-icon.svg';
import { useStore } from '../../../../store';
import { getTotalSavingBalance, getUserBalances } from '../../utils/balance.utils';
import { WidgetLink } from '../../components/WidgetLink';
import { VIEWS_MAP } from '../../../../router/constants';
import { SimpleWidgetSkeleton } from '../../components/skeletons/SimpleWidgetSkeleton';
import { trackMixPanel } from '../../../../services/mixpanel.service';

const testIdPrefix = 'savingsAccountWidget';
export const SavingAccountWidget = ({ isLoading }: { isLoading: boolean }) => {
  const getSummaryData = useStore(state => state.getSummaryData);
  const userBalances = getUserBalances(getSummaryData());
  const savingBalance = getTotalSavingBalance(userBalances);
  const { t } = useTranslation();
  const handleLinkClick = () => {
    trackMixPanel('Act on Manage Savings Account');
  };
  if (isLoading) return (<SimpleWidgetSkeleton />);
  return (
    <div className='w-full h-full px-[18px] py-[16px] flex flex-col justify-between'>
      <div className='flex justify-between'>
        <div>
          <Heading title={t('WIDGET_SAVINGS_ACCOUNT.TITLE')} className='font-metricRSemibold text-sm text-bw08 leading-5 mb-[2px]' testId={`${testIdPrefix}_title`} />
          <BalanceView
            balance={savingBalance}
            testId={`${testIdPrefix}_balance`}
            currencyClassName='font-metricRMedium text-[16px] text-bw08 leading-6 relative top-[-8px]'
            balanceClassName='font-metricR text-[28px] text-bw08 leading-[42px]'
          />
        </div>
        <div>
          <IconSavingAccountBalance />
        </div>
      </div>
      <div>
        <div className='flex justify-between'>
          <Heading title={t('WIDGET_SAVINGS_ACCOUNT.WEEKLY_DEPOSIT')} className='font-metricR text-sm text-bw08 leading-6 mr-[5px]' />
          <WidgetLink linkTitle={t('WIDGETS_SHARED.MANAGE')} linkUrl={`/${VIEWS_MAP.SAVINGS_BUCKET.BASE}`} testId={`${testIdPrefix}_manage-link`} onClick={handleLinkClick} />
        </div>
      </div>
    </div>
  );
};
